import { render, staticRenderFns } from "./session.vue?vue&type=template&id=2f1361c8&scoped=true&"
import script from "./session.vue?vue&type=script&lang=js&"
export * from "./session.vue?vue&type=script&lang=js&"
import style0 from "./session.vue?vue&type=style&index=0&id=2f1361c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1361c8",
  null
  
)

export default component.exports